/*
 *   Copyright (c) 2021
 *   All rights reserved.
 */
import styled, { ITheme } from 'styled-components';
import { Row } from 'antd';

export const HeaderFrame = styled(Row)`
    background: #2c2c2c;
    padding-bottom: 30px;
    box-shadow: 0px 0px 10px 5px rgba(255, 255, 255, 0.3);
    z-index: 2;
    .custom-header {
        margin-top: 15px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        .menu {
        }
        .logo-mobile {
            height: 30px;
            display: flex;
            margin-right: 20px;
            justify-content: center;
            color: white;
        }
        .menu-mobile {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .logo-mobile {
                font-size: 24px;
                font-weight: bold;
            }
        }
        .btn-round {
            background: none;
            border: 0;
            width: 60px !important;
            height: 40px;
            margin-left: 8px;
        }
        .menu-desktop {
            with: 100%;
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: space-between;
            padding: 0 30px;
            .custom-header {
                width: 100%;
                .logo {
                    width: 150px;
                }
            }
            .logo {
                cursor: pointer;
                display: flex;
                align-items: center;
                margin-left: 20px;
            }
            .network {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
        }
        .btn-network {
            width: fit-content !important;
            padding-left: 10px;
            padding-right: 10px;
            height: 30px;
            color: ${({ theme }: { theme: ITheme }) => theme.white};
            margin-right: 12px;
            background: transparent !important;
            border: 2px solid ${({ theme }: { theme: ITheme }) => theme.dark3};
        }
        .btn-network ~ .ant-btn {
            margin-left: 12px;
        }
        .ant-menu {
            width: 100%;
            background: none;
            // padding: 10px 0;
            .ant-menu-item-icon {
                color: white;
            }

            .ant-menu-item a {
                color: white;
            }
            .ant-menu-title-content {
                color: white;
            }
        }
        .ant-menu-horizontal {
            border-bottom: 0;
        }
        .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item,
        .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu {
            padding: 0 10px;
        }

        // display none all hover submenu button
        .ant-menu-horizontal > .ant-menu-item::after,
        .ant-menu-horizontal > .ant-menu-submenu::after {
            border-bottom: none !important;
            transition: none !important;
        }
    }

    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
        .menu-desktop {
            display: none !important;
        }
        .custom-header {
            margin-top: 0;
        }
        .menu-mobile {
            width: 100%;
            display: flex;
            align-items: center;
            padding: 10px 20px;
            .logo-mobile {
                width: 120px;
            }
        }
        .btn-round {
            img {
                width: 30px;
            }
        }
    `}
`;
